import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const listeners = {};
const useIntervalAction = (key, action, interval, leadingEdge = true) => {
	const dispatch = useDispatch();
	useEffect(() => {
		listeners[key] = listeners[key] || { count: 0 };
		listeners[key].count += 1;
		if (listeners[key].count === 1) {
			if (leadingEdge) {
				dispatch(action);
			}
			listeners[key].timer = setInterval(() => {
				dispatch(action);
			}, interval);

			return () => {
				listeners[key].count -= 1;
				if (listeners[key].count < 1) {
					clearInterval(listeners[key].timer);
					listeners[key].count = 0;
				}
			};
		}
	}, [key]); // eslint-disable-line
};

export default useIntervalAction;
